export default {
    token: state => state.app.token,
    siderType: state => state.app.siderType,
    account: state => state.app.account,
    avatarUrl: state => state.app.avatarUrl,
    pedigreeName: state => state.app.pedigreeName,
    updateId: state => state.app.updateId
}
